/**
 * This is just an importer to compile and minify global scripts
 */

require('../../templates/blocks/desktop-nav/desktop-nav.jquery');
require('../../templates/blocks/footer-main/footer-main.jquery');
require('../../templates/blocks/wireframed-calls-to-action/wireframed-calls-to-action.jquery');
require('../../templates/blocks/footer-copyright/scroll-to-top.jquery');
require('../../templates/blocks/mobile-menu-navigation/mobile-menu-navigation.jquery');
require('../../templates/menus/quicklinks/quicklinks.jquery');
require('../../templates/paragraphs/basic-card-slider/basic-card-slider.jquery');
require('../../templates/paragraphs/circle-transition-paragraph/circle-transition-paragraph.jquery');
require('../../templates/paragraphs/faq/faq.jquery');
require('../../templates/paragraphs/hero/hero.jquery');
require('../../templates/paragraphs/historical-timeline/historical-timeline.jquery');
require('../../templates/paragraphs/parallax-formatted-copy/parallax-formatted-copy.jquery');
require('../../templates/paragraphs/scrolling-image-fader/scrolling-image-fader.jquery');
require('../../templates/views/library/library.jquery');
require('../../templates/views/product/product-list-mobile.jquery');
require('../../templates/views/product/related-product-list.jquery');
require('../../templates/views/search/search-toggle.jquery');

require('./custom-form.jquery');
require('./modal.jquery');
require('./product-card.jquery');

// NOTICE: Needs to be loaded after modal.jquery.js
require('../../templates/views/contact-us/request.jquery');
